module.exports = __webpack_public_path__ + "static/cioreview-award-min-cf6021b8f7b62bd0837d15b08aca749c.jpg";